import { useNavigate } from 'react-router-dom';
import { cn } from 'src/lib/utils';

// Also install this npm i --save-dev @types/react-lottie

export const BentoGrid = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return (
    <div
      className={cn(
        // change gap-4 to gap-8, change grid-cols-3 to grid-cols-5, remove md:auto-rows-[18rem], add responsive code
        'grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 md:grid-row-7 gap-4 lg:gap-8 mx-auto',
        className
      )}
    >
      {children}
    </div>
  );
};

interface BentoGridProps {
  className?: string;
  id: number;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  img?: string;
  imgClassName?: string;
  titleClassName?: string;
  spareImg?: string;
  videoLink?: string;
}

export const BentoGridItem = ({
  className,
  id,
  title,
  description,
  //   remove unecessary things here
  img,
  imgClassName,
  titleClassName,
  spareImg,
  videoLink
}: BentoGridProps) => {
  const firstStack = ['', 'Typescript', 'Angular', 'ReactJS'];
  const secondStack = ['', 'NodeJs', 'Python', 'Tailwind'];
  const thirdStack = ['Docker', 'AWS', 'GCP'];
  const fourthStack = ['Git', 'CI/CD', 'GitActions'];

  const navigate = useNavigate();

  return (
    <div
      className={cn(
        // remove p-4 rounded-3xl dark:bg-black dark:border-white/[0.2] bg-white  border border-transparent, add border border-white/[0.1] overflow-hidden relative
        'row-span-1 relative overflow-hidden rounded-3xl border border-white/[0.1] group/bento hover:shadow-xl transition duration-200 shadow-input dark:shadow-none justify-between flex flex-col space-y-4',
        className
      )}
      style={{
        background: 'rgb(4,7,29)',
        backgroundColor: 'linear-gradient(90deg, rgba(4,7,29,1) 0%, rgba(12,14,35,1) 100%)'
      }}
    >
      {/* add img divs */}
      <div className={`${id === 6 && 'flex justify-center'} h-full`}>
        <div className="w-full h-full absolute">
          {videoLink && <video src={videoLink} loop muted autoPlay id="next-video" className="h-full w-full" />}
          {img && <img src={img} alt={img} className={cn(imgClassName, 'object-cover object-center ')} />}
        </div>
        <div className={`absolute right-0 -bottom-5 ${id === 5 && 'w-full opacity-80'} `}>
          {spareImg && (
            <img src={spareImg} alt={spareImg} width={220} className="object-cover object-center w-full h-full" />
          )}
        </div>
        {/* {id === 6 && (
          // add background animation , remove the p tag
          <BackgroundGradientAnimation>
            <div className="absolute z-50 inset-0 flex items-center justify-center text-white font-bold px-4 pointer-events-none text-3xl text-center md:text-4xl lg:text-7xl"></div>
          </BackgroundGradientAnimation>
        )} */}

        <div
          className={cn(
            titleClassName,
            'group-hover/bento:translate-x-2 transition duration-200 relative md:h-full min-h-40 flex flex-col px-5 p-5 lg:p-10'
          )}
        >
          {/* add text-3xl max-w-96 , remove text-neutral-600 dark:text-neutral-300*/}
          {/* remove mb-2 mt-2 */}
          <div className={`font-sans text-lg lg:text-3xl max-w-96 font-bold z-10 `}>{title}</div>
          {/* change the order of the title and des, font-extralight, remove text-xs text-neutral-600 dark:text-neutral-300 , change the text-color */}
          <div className="font-sans font-extralight md:max-w-32 md:text-xs lg:text-base text-sm text-[#C1C2D3] z-10">
            {typeof description === 'string' ? (
              <>
                {description.slice(0, 20) + '...'}
                {description.length > 20 && (
                  <button
                    onClick={() => navigate(`projects/${id}`)}
                    className="ml-1 text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    {'See More'}
                  </button>
                )}
              </>
            ) : (
              description
            )}
          </div>

          {/* for the github 3d globe */}
          {/* {id === 2 && <GridGlobe />} */}

          {/* Tech stack list div */}
          {id === 3 && (
            <div className="flex gap-1 lg:gap-5 w-fit absolute -right-3 lg:-right-2">
              <div className="flex flex-col gap-3 md:gap-3 lg:gap-8">
                {firstStack.map((item, i) => (
                  <span
                    key={i}
                    className="lg:py-4 lg:px-3 py-2 px-3 text-xs lg:text-base opacity-50 
                    lg:opacity-100 rounded-lg text-center bg-[#10132E]"
                  >
                    {item}
                  </span>
                ))}
                <span className="lg:py-4 lg:px-3 py-4 px-3  rounded-lg text-center bg-[#10132E]"></span>
              </div>

              <div className="flex flex-col gap-3 md:gap-3 lg:gap-8">
                {secondStack.map((item, i) => (
                  <span
                    key={i}
                    className="lg:py-6 lg:px-3 py-4 px-3 text-xs lg:text-base opacity-50 
                    lg:opacity-100 rounded-lg text-center bg-[#10132E]"
                  >
                    {item}
                  </span>
                ))}
                <span className="lg:py-4 lg:px-3 py-4 px-3  rounded-lg text-center bg-[#10132E]"></span>
              </div>

              <div className="flex flex-col gap-3 md:gap-3 lg:gap-8">
                {thirdStack.map((item, i) => (
                  <span
                    key={i}
                    className="lg:py-8 lg:px-3 py-6 px-3 text-xs lg:text-base opacity-50 
                    lg:opacity-100 rounded-lg text-center bg-[#10132E]"
                  >
                    {item}
                  </span>
                ))}
                <span className="lg:py-4 lg:px-3 py-4 px-3  rounded-lg text-center bg-[#10132E]"></span>
              </div>

              <div className="flex flex-col gap-3 md:gap-3 lg:gap-8">
                {fourthStack.map((item, i) => (
                  <span
                    key={i}
                    className="lg:py-10 lg:px-3 py-8 px-3 text-xs lg:text-base opacity-50 
                    lg:opacity-100 rounded-lg text-center bg-[#10132E]"
                  >
                    {item}
                  </span>
                ))}
                <span className="lg:py-4 lg:px-3 py-4 px-3  rounded-lg text-center bg-[#10132E]"></span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
